import { Pipe, PipeTransform } from '@angular/core';
import { API_PARAMS } from '../shared/constants/api.constants';

/**
 * 家族病史疾病管道：value添加前綴
 */
@Pipe({
  name: 'familyHistoryDisease',
  standalone: true,
})
export class FamilyHistoryDiseasePipe implements PipeTransform {
  transform(value: unknown, ...args: unknown[]): string {
    return `${API_PARAMS.QUESTIONNAIRE_DISEASE_PREFIX.FAMILY}${value}`;
  }
}
